<template>
  <div class="page-wrapper section-space--inner--120">
    <!--Contact section start-->
    <div class="conact-section">
      <div class="container">
        <div class="row section-space--bottom--50">
          <div class="col">
            <!-- google map component -->
            <!--                        <GoogleMap />-->
            <!-- src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12951.652125161141!2d51.5059789!3d35.7529423!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e03483e87e827%3A0xfd712e084e047e7b!2z2KjYp9i02q_Yp9mHINiq2YbbjNizINmH2Ybar9in2YU!5e0!3m2!1sen!2s!4v1687771465379!5m2!1sen!2s" -->

            <iframe
              :src="getSettings.google_map_link.value"
              width="100%"
              height="400"
              frameborder="0"
              style="border:0;"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="contact-information">
              <h3>{{ data.contactInfo.title }}</h3>
              <ul>
                <li>
                  <span class="icon">
                    <i :class="data.contactInfo.address.icon"></i>
                  </span>
                  <span class="text">
                    {{ getSettings.address.value }}
                  </span>
                </li>
                <li>
                  <span class="icon">
                    <i :class="data.contactInfo.telephone.icon"></i>
                  </span>
                  <span class="text">
                    <a :href="'tel:' + getSettings.phone.value">{{
                      getSettings.phone.value
                    }}</a>
                    <!-- <a href="tel:123456789">{{
                      data.contactInfo.telephone.no_1
                    }}</a> -->
                  </span>
                </li>
                <li>
                  <span class="icon"
                    ><i :class="data.contactInfo.mail.icon"></i
                  ></span>
                  <span class="text">
                    <a :href="'mailto:' + getSettings.contact_email.value">{{
                      getSettings.contact_email.value
                    }}</a>
                    <!-- <a href="#">{{ data.contactInfo.mail.web }}</a> -->
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="col-lg-8 col-12">
                        <div class="contact-form">
                            <h3>پیام خود را ارسال کنید</h3>
                            <form id="contact-form">
                                <div class="row row-10">
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input name="con_name" type="text" placeholder="نام">
                                    </div>
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input name="con_email" type="email" placeholder="ایمیل">
                                    </div>
                                    <div class="col-12">
                                        <textarea name="con_message" placeholder="پیام شما"></textarea>
                                    </div>
                                    <div class="col-12">
                                        <button>ارسال پیام</button>
                                    </div>
                                </div>
                            </form>
                            <p class="form-message"></p>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
    <!--Contact section end-->
  </div>
</template>

<script>
import data from "../../data/contact.json"
import GoogleMap from "@/components/GoogleMap"
import { settingStore } from "@/store/Modules/setting.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  components: {
    GoogleMap,
  },
  computed: {
    ...mapState(settingStore, ["getSettings"]),
  },
  data() {
    return {
      data,
    }
  },
}
</script>
